import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/tabview';
import { AppRightPanelComponent } from './menu/app.rightpanel.component';
import { DialogModule } from 'primeng/dialog';
import { AppProfileComponent } from './topbar/app.profile.component';








@NgModule({
    declarations: [],
    exports: [],
    imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        TabViewModule,
        DialogModule

        ],
    providers: []
})
export class LayoutModule { }
